var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.984 11.194 30.7 19.91c.54.54.544 1.413.01 1.958l-8.715 8.905a1.392 1.392 0 0 1-1.99 0l-8.716-8.905a1.392 1.392 0 0 1 .01-1.958l8.717-8.716a1.392 1.392 0 0 1 1.968 0z",
    fill: "#F54751"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.313 1.313 18.266 18.266c.722.722.725 1.891.007 2.618L22.32 40.665a1.856 1.856 0 0 1-2.64 0L1.414 22.197a1.856 1.856 0 0 1 .007-2.618L19.687 1.313a1.856 1.856 0 0 1 2.626 0z",
    strokeOpacity: 0.4,
    stroke: "#F54751",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.984 4.233 15.673 15.673c.541.541.544 1.418.007 1.962L21.99 37.748a1.392 1.392 0 0 1-1.982 0L4.336 21.867a1.392 1.392 0 0 1 .007-1.962L20.016 4.233a1.392 1.392 0 0 1 1.968 0z",
    stroke: "#F54751",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLapse);
export default __webpack_public_path__ + "static/media/icon-lapse.50d3ae7528d2adee2b9a5283654fbc9d.svg";
export { ForwardRef as ReactComponent };